import { createContext } from 'react';

const PreQualificationPagesContext = createContext();

export default PreQualificationPagesContext;
